import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/button'
import { ListMenuCard } from '../../../components/channelCuration/ListMenuCard'
import { EmptyState } from '../../../components/emptyState/emptyState'
import Spinner from '../../../components/spinner/Spinner'
import { PageHeader } from '../../../components/typography/PageHeader'
import Layout from '../../../layout'
import {
  useFetchListMenusQuery,
  useReorderListMenusMutation,
} from '../../../redux-toolkits/list-menu/listMenu.slice'
import { ListMenuItem } from '../../../redux-toolkits/list-menu/listMenu.types'

export const NavMenuPage = () => {
  const navigate = useNavigate()
  const [orderedMenus, setOrderedMenus] = useState<ListMenuItem[]>([])

  const { data, isLoading, refetch } = useFetchListMenusQuery(
    {
      page: 1,
      limit: 100,
    },
    { refetchOnMountOrArgChange: true },
  )

  const [reorderListMenus, { isLoading: isReordering }] =
    useReorderListMenusMutation()

  const handleMoveUp = async (index: number) => {
    if (index === 0) return
    const newOrder = [...orderedMenus]
    ;[newOrder[index - 1], newOrder[index]] = [
      newOrder[index],
      newOrder[index - 1],
    ]
    setOrderedMenus(newOrder)
    await reorderListMenus({ listMenuIds: newOrder.map((m) => m._id) })
  }

  const handleMoveDown = async (index: number) => {
    if (index === orderedMenus.length - 1) return
    const newOrder = [...orderedMenus]
    ;[newOrder[index], newOrder[index + 1]] = [
      newOrder[index + 1],
      newOrder[index],
    ]
    setOrderedMenus(newOrder)
    await reorderListMenus({ listMenuIds: newOrder.map((m) => m._id) })
  }

  useEffect(() => {
    if (data?.data.docs) {
      setOrderedMenus(
        [...data.data.docs].sort((a, b) => a.position - b.position),
      )
    }
  }, [data])

  return (
    <Layout>
      <div className="flex items-center justify-between mb-10">
        <PageHeader title="Nav Menu" className="!mb-0" />
        <Button
          primary
          label="Add List Menu"
          onClick={() => navigate('/channel-curation/nav-menu/new')}
        />
      </div>

      {isLoading ? (
        <Spinner fullScreen={false} />
      ) : orderedMenus.length === 0 ? (
        <EmptyState text="No list menus yet. Create one to get started." />
      ) : (
        <div className="flex flex-col gap-4">
          {orderedMenus.map((menu, index) => (
            <ListMenuCard
              key={menu._id}
              menu={menu}
              isFirst={index === 0}
              isLast={index === orderedMenus.length - 1}
              isReordering={isReordering}
              onMoveUp={() => handleMoveUp(index)}
              onMoveDown={() => handleMoveDown(index)}
            />
          ))}
        </div>
      )}
    </Layout>
  )
}
